"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _constants = require("../CreateGift/constants");

var statusesIcons = {
  [_constants.giftStatuses.GIFT_CREATED]: 'flask',
  [_constants.giftStatuses.NEED_MORE_INFO]: 'pencil',
  [_constants.giftStatuses.REVIEW]: 'flask',
  [_constants.giftStatuses.PRODUCTS_PROPOSED]: 'lightbulb-on',
  [_constants.giftStatuses.DISABLED]: 'ban'
};
var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    image: {
      height: 'auto',
      width: 60,
      border: "1px solid ".concat(palette.divider),
      marginRight: spacing(2)
    },
    giftStatusIcon: {
      fontSize: 30,
      width: 'auto',
      color: palette.green.fruitSalad
    },
    iconWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: 60,
      minHeight: 60,
      border: "1px solid ".concat(palette.divider),
      marginRight: spacing(2)
    }
  };
});

var GiftImage = function GiftImage(_ref2) {
  var status = _ref2.status,
      image = _ref2.image,
      title = _ref2.title;
  var classes = useStyles();
  var icon = statusesIcons[status];
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, icon ? /*#__PURE__*/_react.default.createElement("div", {
    className: classes.iconWrapper
  }, /*#__PURE__*/_react.default.createElement(_ui.DashboardIcon, {
    icon: icon,
    className: classes.giftStatusIcon
  })) : /*#__PURE__*/_react.default.createElement("img", {
    src: image,
    alt: title,
    className: classes.image
  }));
};

GiftImage.propTypes = {
  status: _propTypes.default.number.isRequired,
  title: _propTypes.default.string.isRequired,
  image: _propTypes.default.string
};
GiftImage.defaultProps = {
  image: ''
};

var _default = /*#__PURE__*/(0, _react.memo)(GiftImage);

exports.default = _default;